import { type QueryContext } from '@/features/shared/utils/dataFetching/types'
import { isProduction, isRunningTests } from '@/features/shared/utils/environment'

export const NO_GET_ACCESS_TOKEN_ERROR = new Error(
  'getAccessToken requires query context when called on the server',
)

export const getServerAccessTokenWithContext = (
  context: QueryContext | undefined,
  // the REST request URL or GraphQL query being made, used to add context to error logs
  request: string,
): Promise<string | undefined> => {
  if (!context?.meta?.getAccessToken) {
    if (!isProduction && !isRunningTests) {
      // oxlint-disable-next-line no-console -- logging this is useful for debugging
      console.error(`${NO_GET_ACCESS_TOKEN_ERROR}: ${request}`)
    }
    throw NO_GET_ACCESS_TOKEN_ERROR
  }
  return context.meta.getAccessToken()
}
